/**
 * Created by commyfeng on 2016/10/19.
 */

import alertComponent from './alertComponent.vue'
import toastComponent from './toastComponent.vue'
import shareComponent from './shareComponent.vue'
import loginComponent from './loginComponent.vue'
import loadingComponent from './loadingComponent.vue'
let DialogPlugin = {}

DialogPlugin.install = function (Vue, option) {
  let installComponent = { alertComponent, toastComponent, shareComponent, loginComponent, loadingComponent }
  for (let name in installComponent) {
    let div = document.createElement('div')
    document.body.appendChild(div)
    let VueComponent = Vue.extend(installComponent[name])
    let instance = (new VueComponent()).$mount(div)

    let func = installComponent[name].install(Vue, instance)
    if (typeof func === 'object') {
      for (let i in func) {
        DialogPlugin[i] = func[i]
      }
    } else if (typeof func === 'function') {
      DialogPlugin[name.replace('Component', '')] = func
    }
  }
}

export default DialogPlugin
